
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorPlaceholder as ObiCursorPlaceholderElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-placeholder.js';
 
 
 

 
 export const ObiCursorPlaceholder = createComponent({
   react: React,
   tagName: 'obi-cursor-placeholder',
   elementClass: ObiCursorPlaceholderElement,
   events: {
     
   }
  });
 
 